import { SourceTypeEnum } from '../../../api/source/enums/source-type.enum';

export enum SearchCriteriaSourcesEnum {
    journalist = 'CONTACTS',
    outlet = 'OUTLETS',
    urls = 'URLS',
    sourceGroups = 'SOURCE_GROUPS'
}

export const searchCriteriaSourcesEnumToSourceTypeEnum = new Map<SearchCriteriaSourcesEnum, SourceTypeEnum>([
    [SearchCriteriaSourcesEnum.journalist, SourceTypeEnum.journalist],
    [SearchCriteriaSourcesEnum.outlet, SourceTypeEnum.outlet],
    [SearchCriteriaSourcesEnum.urls, SourceTypeEnum.url],
    [SearchCriteriaSourcesEnum.sourceGroups, SourceTypeEnum.sourceGroup]
]);
export const sourceTypeEnumToSearchCriteriaSourcesEnum = new Map<SourceTypeEnum, SearchCriteriaSourcesEnum>([
    [SourceTypeEnum.journalist, SearchCriteriaSourcesEnum.journalist],
    [SourceTypeEnum.outlet, SearchCriteriaSourcesEnum.outlet],
    [SourceTypeEnum.url, SearchCriteriaSourcesEnum.urls],
    [SourceTypeEnum.sourceGroup, SearchCriteriaSourcesEnum.sourceGroups]
]);
